/**
 * Internal dependencies
 */
import { lcm } from './lcm';
import type { Session } from '../../types';

export function getNumberOfAlternatives( session: Session ): number {
	const altCounts = session.experiments
		.filter( ( e ) => e.active )
		.map( ( e ) => e.alternatives.length )
		.filter( ( as ) => !! as );

	if ( ! altCounts.length ) {
		return 1;
	}

	return altCounts.reduce( lcm, 1 );
}
